import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-fscs-muted">
        <span className="fscs-label">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Suspended members can't access protected pages. The admin panel is the
  // one exception so we can still moderate (admins are never suspended).
  if (
    typeof user === "object" &&
    user.subscription_status === "suspended" &&
    user.role !== "admin" &&
    location.pathname !== "/suspended"
  ) {
    return <Navigate to="/suspended" replace />;
  }

  // First-time users land on /onboarding. /onboarding itself is protected
  // but should not redirect to itself in an infinite loop. Admins skip it.
  const needsOnboarding =
    typeof user === "object" &&
    !user.onboarded_at &&
    user.role !== "admin";
  if (needsOnboarding && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
